import { SvgIcon, Typography } from "@mui/material";

import { MoonIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { NightReportMetric } from "interfaces/nightReport.interface";

import { MetricBadge } from "../../../../../NightReportScreen/components/MetricBadge";
import { StatCard } from "../components/StatCard";

type SleepTimeCardProps = {
  totalSleepTime: string;
  totalSleepTimeMetric: NightReportMetric | null;
};

export function SleepTimeCard({
  totalSleepTime,
  totalSleepTimeMetric,
}: SleepTimeCardProps) {
  const { t } = useTranslation();

  return (
    <StatCard>
      <SvgIcon component={MoonIcon} color={"neutral.decoration"} />
      <Typography
        variant={"bodySmallMedium"}
        sx={{
          color: "neutral.subtle",
        }}
      >
        {t("Total Sleep Time")}
      </Typography>
      <Typography variant={"headingLargeRegular"}>{totalSleepTime}</Typography>
      {totalSleepTimeMetric?.deviation_pct && (
        <MetricBadge
          showPercent
          metric={totalSleepTimeMetric}
          alertMetric={"time_asleep"}
          delta={totalSleepTimeMetric.deviation_pct}
          sx={{ alignSelf: "self-start" }}
        />
      )}
    </StatCard>
  );
}
